(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[594],{

/***/ 3771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ noteTraditional; }
/* harmony export */ });
var noteTraditional = function noteTraditional(data, hideInitialNote) {
  var dataTraditional = data;
  var getSingapore = dataTraditional === null || dataTraditional === void 0 ? void 0 : dataTraditional.find(function (item) {
    return item.id === 191;
  });
  var findSpecialBank = getSingapore === null || getSingapore === void 0 ? void 0 : getSingapore.banks.find(function (item) {
    return item.name === "OCBC Bank*";
  });
  var note = "**Initial deposit is often blocked in the offshore bank account; if so, this amount is often small.<br/> However, banks in Hong Kong and Singapore do not freeze this amount, so you can use it freely. But you will be charged an additional fee for not maintaining your account above min balance.";

  if (getSingapore && findSpecialBank) {
    if (hideInitialNote) {
      note = "* Remote opening applies for Singapore-incorporated companies only.";
    } else {
      note += "<br/>* Remote opening applies for Singapore-incorporated companies only.";
    }
  } else {
    if (hideInitialNote) {
      note = null;
    }
  }

  return note;
};

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 25637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/** ========== */





var WhyChooseUs = function WhyChooseUs(_ref) {
  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      note = _ref.note,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("section", {
    className: sectionClassName,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        children: [note && note.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
            className: "mb-10 text-center text-white",
            dangerouslySetInnerHTML: {
              __html: note
            }
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-10"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "row justify-center gap-y-6 lg:gap-y-10",
          children: data.length > 0 && data.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
              className: "col-12 ".concat(data.length === 4 ? "lg:col-3" : "lg:col-4"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: "text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                  src: item.icon.src,
                  alt: item.icon.altText,
                  width: 48,
                  height: 48,
                  wrapper: {
                    className: "flex items-center justify-center bg-white rounded-[26px] h-20 w-20  mx-auto"
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                  className: "flex justify-center",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    as: "h3",
                    text: item.title,
                    className: "mt-6 w-5/6 text-lg font-semibold normal-case text-white"
                  })
                }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                  className: "mt-3 !normal-case text-white",
                  children: item.description
                })]
              })
            }, index);
          })
        })]
      })
    }), children]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WhyChooseUs);
WhyChooseUs.defaultProps = {
  title: "",
  data: [],
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 94080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/bs/BsCheck.js
var BsCheck = __webpack_require__(19727);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/organisms/BankingOptions/index.js + 1 modules
var BankingOptions = __webpack_require__(25497);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/HowItWorks/index.js
var HowItWorks = __webpack_require__(78354);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/WhyChooseUs/index.js
var WhyChooseUs = __webpack_require__(25637);
// EXTERNAL MODULE: ./components/organisms/BankingOptions/bankNote.js
var bankNote = __webpack_require__(3771);
// EXTERNAL MODULE: ./components/templates/offshore/banking-support/Index.module.scss
var Index_module = __webpack_require__(43671);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/banking-support/index.js

















var NewsSlider = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(1290)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/offshore/banking-support/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var BankingSupport = function BankingSupport(_ref) {
  var _dataJson$dataBanking, _dataJson$dataBanking2;

  var dataJson = _ref.dataJson,
      data = _ref.data,
      dataBank = _ref.dataBank;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-569",
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: "Opening A Corporate <br/>Bank account",
      leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 text-center lg:col-11 lg:mb-14 lg:text-left",
        children: "Worldwide banking with professional support and careful process in step-by-step"
      }),
      titleProps: {
        className: "banner-default-title mb-6 capitalize",
        textColor: "bg-bbc-gradient-liner1 text-transparent bg-clip-text"
      },
      leftClassName: "lg:col-7 lg:pr-[65px] lg:mb-10",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/banking-support/banner-offshore-banking.png",
        wrapper: {
          className: "bbc-banner-image-country pb-20 lg:pb-10 "
        },
        className: "h-full w-full",
        width: 622,
        height: 400,
        alt: "offshore bank account opening support service"
      }),
      bgColor: "bg-bbc-gradient-service"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "relative z-10 ".concat((Index_module_default()).bankingTool),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "lg:container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col-reverse items-center rounded-3xl bg-bbc-gradient-liner1 px-6 pb-6 pt-10 lg:flex-row ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "text-center lg:col-5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "mb-6 text-left text-3xl font-semibold text-bbc-main",
                children: ["BBCIncorp\u2019s Online", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Banking Tool"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 text-left text-bbc-white",
                children: "Simplify your banking choice with easy steps"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                  as: "a",
                  href: "/guide-and-tool/banking-tool",
                  variant: "outline",
                  useRouter: true,
                  btnBorder: "border border-white",
                  btnColor: "bg-transparent hover:bg-white",
                  btnTextColor: "text-white hover:text-bbc-brand-500",
                  children: "Try Now"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:col-7",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/offshore/banking-support/services1-offshore-banking.png",
                className: "",
                alt: "Banking Tool",
                width: 544,
                height: 432
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6 ",
          children: "Cannot do business without banking?"
        }), dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataBanking = dataJson.dataBanking) === null || _dataJson$dataBanking === void 0 ? void 0 : _dataJson$dataBanking.description.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 last:mb-10",
            children: item
          }, index);
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:col-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "mb-4 text-2xl font-semibold text-bbc-brand-800 ",
              children: "Offshore banking benefits"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataBanking2 = dataJson.dataBanking) === null || _dataJson$dataBanking2 === void 0 ? void 0 : _dataJson$dataBanking2.lists.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "mb-3 flex",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "pt-[4px]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BsCheck/* BsCheck */.o, {
                      className: " mr-2 text-bbc-brand-400"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: item
                  })]
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "order-first mb-6 lg:col-6 lg:order-last lg:mb-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/banking-support/benefits-offshore-banking.png",
              className: "h-full w-full",
              width: 537,
              height: 340,
              alt: "benefits of offshore business bank account"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyChooseUs/* default */.Z, {
      title: "Why choose us for banking introduction",
      sectionClassName: "bg-bbc-gradient-3 py-10 lg:py-20 capitalize",
      data: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataWhyChooseUs
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
        data: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataMakeItWork,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
          className: "text-center font-semibold capitalize lg:text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block text-3xl text-bbc-brand-800 lg:text-bbc-40px",
            children: "How"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "mt-4 block text-3xl text-bbc-brand-700 lg:text-4xl lg:leading-[44px]",
            children: "It Works"
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankingOptions/* default */.Z, {
          title: "Countries for Overseas Banking",
          description: "It does not mean that a BVI company must choose a bank account in BVI. Many owners of offshore companies tend to incorporate their companies in one country and open the offshore accounts independently, in a location that is known as a \u201Cfinancial centre\u201D. Examples of widely known financial centres are Hong Kong Singapore, Switzerland, Austria or Luxembourg. We offer bank account introductions in several major jurisdictions, and in many cases, depending on client's business profile and needs, one bank might be preferred over others.",
          dataTraditional: dataBank === null || dataBank === void 0 ? void 0 : dataBank.traditional,
          dataEMI: dataBank === null || dataBank === void 0 ? void 0 : dataBank.emi,
          noteTraditional: (0,bankNote/* noteTraditional */.R)(dataBank.traditional, true)
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
        sectionClassName: " pt-14 pb-20",
        backgroundImage: "/assets/images/common/required-documents.png",
        title: "Document requirements",
        data: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataRequiredDocuments
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs // Description =""

          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var banking_support = (BankingSupport);
;// CONCATENATED MODULE: ./pages/offshore/banking-support/data.json
var data_namespaceObject = JSON.parse('{"breadcrumbs":[{"uri":"/","title":"Home"},{"uri":"/banking-support","title":"Opening a corporate bank account"}],"dataBanking":{"description":["We know, in most cases, your business cannot be operated if your company has no corporate bank account. Despite what business objectives you have, setting up a proper company bank account is an integral part of any business plan. Different countries have their own local banking laws, and each bank has different account types with corresponding procedures and required documents to follow. The whole process would cost you several months and missed potential business opportunities before you know what works best.","We could help to cut your waiting time to just a few weeks or less, and only cost you a small fraction of what you might have otherwise spent by opening account yourself. Beside supporting our customers to open bank accounts with a bank interview in financial centres like Hong Kong, Singapore,… we have long-term profitable relationships with banks in other countries/ jurisdictions, which are well-known for their offshore banking systems such as Switzerland, Belize, Mauritius… As one of their advantages, you can open offshore business bank account online in a streamlined manner without a signatory travel."],"lists":["Operating bank accounts for your offshore company.","Access to global markets for trading and investment purposes.","Super easy and convenient to make international payments with no currency control.","Support multi-currency accounts including USD, EUR, GBP, SGD, HKD, AUD, etc.","Protect your assets.","High level of data confidentiality.","Availability of specialized or customized products/services.","Facilitate transactions with 24/7 internet banking, debit/credit card, etc."]},"dataWhyChooseUs":[{"icon":{"src":"/assets/icons/shake-hands.svg","altText":"wallet icon"},"title":"Broad banking network","description":"Our long-term relationships with banks in many jurisdictions allow us to offer a solution that best matches your situation and business needs"},{"icon":{"src":"/assets/icons/why-choose-local-expertise.svg","altText":"shield icon"},"title":"Local expertise","description":"Our extensive working experience with banks will make you better prepared for due diligence process, and thus improve chances of bank account approval"},{"icon":{"src":"/assets/icons/piggy-bank.svg","altText":"title icon"},"title":"Flat pricing","description":"No need to worry about hidden charges. Whichever bank you choose from our list, we only charge you a small flat fee"}],"dataMakeItWork":[{"title":"Understand the case","content":"Our banking consultants will work with you to strive to make clear your business conditions and expectations before giving you advice on available banks with whom you should open your corporate bank account."},{"title":"Collect and Verify document","content":"Based on the agreement, we will proceed to help you prepare for required documents in the best way that could increase your success rate."},{"title":"Schedule bank meeting","content":"Depending on each bank’s obligation, we will arrange a bank meeting with your selected bank representative to set up your bank accounts. Before the meeting, we will give you samples of interview question for preparation."},{"title":"Bank Account approval","content":"We do not guarantee to successfully open your bank account. It totally depends on the bank’s decision to approve your account or not. The process could take a week or more."}],"dataRequiredDocuments":{"button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"During bank account application process, we will help you to prepare documents in the right way not only to save your time but also to make you in a better position to be approved by the bank."},{"title":"The below lines will give you a good reference to start with","listContent":[{"text":"KYC form","content":[]},{"text":"Bank statements","content":[]},{"text":"Bank Reference letter","content":[]},{"text":"CV of shareholder(s)/director(s)","content":[]},{"text":"Business plan","content":[]},{"text":"Trading proofs","content":[]},{"text":"Information of some major clients, suppliers or partners","content":[]}]}]},"dataFaqs":[{"name":"How to open offshore business bank account online?","content":"<p>Typically, you\'ll need to find an offshore bank that might best suit your business needs. The required documentation to open your offshore business account may vary from bank to bank; in most cases, you will need to submit your identity proof, your overseas address, the source of deposits, etc.</p>"},{"name":"How much does it cost to open an offshore bank account?","content":"<p>It depends on your selected offshore bank, the jurisdiction in which you want to open your corporate account, the application fee, the notarized document fee to set up the account (if any), etc. It is recommended that trusted Offshore Banking Services instead of opening account by yourself would help avoid waste of time and money caused by the requirement and related costs during your account opening process.</p>"},{"name":"Which country is best for offshore account?","content":"<p>Some popular choices for offshore banking include Switzerland, Belize, British Virgin Islands, Singapore, Hong Kong, Mauritius. Each country has its own advantages and disadvantages, so it\'s important to pick one that\'s right for your business.</p><p>For further information, you can check this blog out: <a href=\'/offshore/articles/countries-with-best-offshore-bank-accounts\' target=\'_blank\' rel=\'nofollow noreferrer noopener\'>Top 9 Countries With Best Offshore Bank Accounts</a></p><p>Feel free to contact our dedicated Relationship Managers via <a href=\'mailto:service@bbcincorp.com\'>service@bbcincorp.com</a> for detailed instructions on how to open offshore business account online.</p>"}]}');
;// CONCATENATED MODULE: ./pages/offshore/banking-support/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(banking_support, {
        dataBank: {
          traditional: bank_country/* banking_support */.xy,
          emi: bank_emis/* banking_support */.xy
        },
        dataJson: data_namespaceObject,
        data: data
      })
    })
  });
}

/***/ }),

/***/ 2372:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/banking-support",
      function () {
        return __webpack_require__(94080);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43671:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bankingTool":"Index_bankingTool___EzWL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,9156,2864,58,5881,5999,2888,179], function() { return __webpack_exec__(2372); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);